module.exports = __webpack_public_path__ + "static/media/base_collection_img.534611f3.svg";